<template>
  <div class="orderSearchList search" :style="noSearchShow ? { background: '#fff' } : {}">
    <header>
      <!--<img src="../../assets/images/search.png">-->
      <!--<input type="text" placeholder="搜索“可丽金洗护套盒”" v-focus="isShow">-->
      <form action="/">
        <van-search
          v-model="searchValue"
          placeholder="订单号、收件人、商品名称"
          show-action
          clearable
          maxlength="32"
          @search="search"
          @cancel="cancel"
        />
      </form>
      <!--<span @click="cancel">取消</span>-->
    </header>
    <Scroller
      v-if="!noSearchShow"
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      class="my_scroller"
      ref="my_scroller"
    >
      <div v-if="list.length > 0" class="list">
        <ul>
          <li v-for="(item, index) of list" :key="index">
            <p>
              <span>
                <b>{{ item.order_from }}</b>
                <b>
                  {{ item.no }}
                  <img v-if="item.isoversea == 1" src="../../assets/images/haiwai.png" />
                  <img v-if="item.issplit == 1" src="../../assets/images/chai.png" />
                </b>
              </span>
              <b>
                <i class="flex">
                  {{ item.orderstatus_text }}
                  <span
                    class="color-FC0324"
                    v-if="item.isGroupOrder == 1 && item.groupJoinNum > 0 && item.orderstatus == 2"
                  >
                    {{ `(还差${item.groupJoinNum}人拼团成功)` }}
                  </span>
                </i>
                <b
                  v-if="
                    item.orderstatus == 0 ||
                    item.orderstatus == 3 ||
                    item.orderstatus == 6 ||
                    item.orderstatus == 5
                  "
                  @click="deleteFn(item, index)"
                >
                  <img src="../../assets/images/delete1.png" />
                </b>
              </b>
            </p>
            <div class="product" @click="detailsClick(item)">
              <div v-if="item.itemlist && item.itemlist.length <= 1" class="productBox">
                <div class="img">
                  <img v-lazy="item.itemlist[0].img_path" />
                  <goods-tag :goods="item.itemlist[0]"></goods-tag>
                </div>
                <div class="proContent">
                  <b>{{ item.itemlist[0].name }}</b>
                  <p>
                    <b>{{ item.itemlist[0].spec }}</b>
                  </p>
                </div>
              </div>
              <div
                v-show="item.itemlist && item.itemlist.length > 1"
                class="bestSellingSwiper over-h pos-r"
              >
                <swiper :options="swiperOption" ref="mySwiper">
                  <swiper-slide v-for="(itemSon, idx) of item.itemlist" :key="idx">
                    <div class="img">
                      <img v-lazy="itemSon.img_path" />
                      <goods-tag :goods="itemSon"></goods-tag>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <span
                class="totalPrice"
                :class="{
                  totalPriceNoShadow: item.itemlist && item.itemlist.length < 4,
                  totalPriceShadow: item.itemlist && item.itemlist.length >= 4
                }"
              >
                <span class="price">
                  {{
                    String(parseFloat(item.ordermoney).toFixed(2)).slice(
                      0,
                      String(parseFloat(item.ordermoney).toFixed(2)).indexOf('.')
                    )
                  }}
                  <i>
                    {{
                      String(parseFloat(item.ordermoney).toFixed(2)).slice(
                        String(parseFloat(item.ordermoney).toFixed(2)).indexOf('.'),
                        String(parseFloat(item.ordermoney).toFixed(2)).length
                      )
                    }}
                  </i>
                </span>
                <b>共{{ item.item_nums }}件</b>
              </span>
            </div>
            <div class="proFooter">
              <div
                class="p q"
                :class="{ spread: spread == index || item.presalepopup.length == 1 }"
                v-if="item.presalepopup && item.presalepopup.length"
              >
                <p
                  @click.stop="isSpreadFn(index)"
                  :class="{ spread: spread == index || item.presalepopup.length == 1 }"
                  v-for="(itemPresell, indexPresell) of item.presalepopup"
                >
                  <span>{{ itemPresell }}</span>
                  <van-icon
                    v-if="indexPresell == 0 && item.presalepopup.length > 1"
                    color="#B7B7B7"
                    :name="spread == index ? 'arrow-up' : 'arrow-down'"
                  />
                </p>
              </div>
              <div class="p">
                <p
                  class="jc-fs"
                  :class="'countDown' + index"
                  v-if="item.orderstatus == 1 && item.isdeposit == 1 && item.finalpaystatus == 0"
                >
                  {{ dateFn(item.finalpaymenttime, 'datetimestr') }}开始付尾款
                </p>
                <p
                  class="jc-fs"
                  :class="'countDown' + index"
                  v-if="item.orderstatus == 1 && item.isdeposit == 1 && item.finalpaystatus == 1"
                >
                  {{ dateFn(item.finalpaymenttime, 'datetimestr') }}截止付尾款
                </p>
                <p
                  class="jc-fs"
                  :class="'countDown' + index"
                  v-if="item.orderstatus == 1 && item.isdeposit != 1"
                >
                  剩
                  <van-count-down
                    @finish="finish(index)"
                    :time="item.time"
                    format="HH 时 mm 分 ss 秒"
                  />
                  关闭交易
                </p>
                <p class="jc-fs" v-if="item.areaException == 1">
                  <img
                    class="mr3"
                    style="width: 0.14rem; height: 0.14rem"
                    src="../../assets/images/presell.png"
                  />
                  订单地址异常，无法正常发货
                </p>
                <p
                  class="jc-fs"
                  v-if="item.isGroupOrder == 1 && item.groupJoinNum > 0 && item.orderstatus == 2"
                >
                  如果订单未拼成功，将自动退款
                </p>
              </div>
              <div class="proBtn">
                <!--发起拼团分享-->
                <button
                  v-if="item.isGroupOrder == 1 && item.groupJoinNum > 0 && item.orderstatus == 2"
                  class="redBtn"
                  @click="groupShare(item)"
                >
                  邀请好友购买
                </button>
                <button
                  v-if="item.areaException == 1 && item.time == 0"
                  class="grayBtn"
                  @click.stop="keFu(item)"
                >
                  联系客服
                </button>
                <button
                  v-if="item.relationorders && item.relationorders.length > 0"
                  class="grayBtn"
                  @click.stop="relationordersFn(item)"
                >
                  补发订单
                </button>
                <button v-if="item.orderstatus == 1" class="grayBtn" @click="cancelFn(item)">
                  取消订单
                </button>
                <button
                  v-if="(item.orderstatus == 2 || item.orderstatus == 7) && item.status != 2"
                  class="grayBtn"
                  @click="checkTrans(item)"
                >
                  查看物流
                </button>
                <button
                  v-if="
                    (item.orderstatus == 3 || item.orderstatus == 6) &&
                    item.iscomment == 0 &&
                    item.is_act_order == 0
                  "
                  class="grayBtn"
                  @click="detailsClick(item)"
                >
                  评价晒单
                </button>
                <button
                  v-if="
                    (item.orderstatus == 4 || item.orderstatus == 5) &&
                    (item.status == 10 || item.status == 11) &&
                    item.order_type == 0
                  "
                  class="grayBtn"
                  @click="afterDetailsClick(item)"
                >
                  售后详情
                </button>
                <button v-if="item.orderstatus == 1" class="redBtn" @click="goBuy(item)">
                  去支付
                </button>
                <button
                  v-if="(item.orderstatus == 2 && item.status != 2) || item.orderstatus == 7"
                  class="redBtn"
                  @click="confirm(item, index)"
                >
                  确认收货
                </button>
                <button
                  v-if="
                    (item.orderstatus == 2 ||
                      item.orderstatus == 3 ||
                      item.orderstatus == 6 ||
                      item.orderstatus == 7) &&
                    item.changebuystatus
                  "
                  class="redBtn"
                  @click="goProductList(item)"
                >
                  去换购
                </button>
                <button
                  v-if="
                    (item.orderstatus == 2 ||
                      item.orderstatus == 3 ||
                      item.orderstatus == 6 ||
                      item.orderstatus == 7) &&
                    !item.changebuystatus &&
                    item.isexchange
                  "
                  class="redBtn"
                  @click="goProductList(item)"
                >
                  去加购
                </button>
                <button
                  v-if="
                    (item.orderstatus == 0 || item.orderstatus == 4 || item.orderstatus == 5) &&
                    item.is_act_order != 1 &&
                    item.isdeposit != 1 &&
                    item.issubscribeorder != 1 &&
                    item.isMayTwentyAct != 1
                  "
                  class="redBtn"
                  @click="buyAgain(item)"
                >
                  重新购买
                </button>
                <button
                  v-if="
                    (item.orderstatus == 3 || item.orderstatus == 6) &&
                    item.is_act_order != 1 &&
                    item.isdeposit != 1 &&
                    item.isMayTwentyAct != 1
                  "
                  class="redBtn"
                  @click="buyAgain(item)"
                >
                  再次购买
                </button>
                <button
                  v-if="item.showtrial == 1"
                  class="redBtn orangeBtn"
                  @click="$router.push('/applyrecord')"
                >
                  试用反馈
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </Scroller>
    <empty v-if="noSearchShow" :path="'noSearch'"></empty>
    <van-overlay :show="showshare" z-index="100">
      <div class="sharecontainer" v-if="showshare === true">
        <img src="../../assets/images/sharemc.png" />
        <van-button round plain type="danger" class="know" @click="showshare = false">
          我知道了
        </van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, fenxiang, isWx, download_dialog, kefu } from '../../assets/common/js/config'
import { joinShare } from './js/methods'
import Scroller from '../common/Scroller'
import empty from '../emptypage/empty'
import Vue from 'vue'
import goodsTag from '../common/goodsTag'

Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'orderSearchList',
  // decodeURIComponent
  data() {
    return {
      list: [],
      spread: null,
      noSearchShow: false,
      historyList: [],
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 10
      },
      searchValue: '',
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      showshare: false
    }
  },
  components: {
    Scroller,
    empty,
    goodsTag
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'ordersearchlist' })
    }
    if (this.$route.query.searchval) {
      this.searchValue = decodeURIComponent(this.$route.query.searchval)
    }
    if (this.searchValue !== '') {
      this.noRepeat()
    }
    // this.nowPage = 1
    // this.list = []
    // this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        vm.nowPage = 0
      })
    } else {
      next((vm) => {
        if (
          (from.path != '/orderdetails' && from.path != '/cart') ||
          vm.$store.state.orderInitData == 1
        )
          Object.assign(vm.$data, vm.$options.data())
        if (vm.$route.query.searchval) {
          vm.searchValue = decodeURIComponent(vm.$route.query.searchval)
        }
        if (vm.searchValue !== '') {
          vm.noRepeat()
        }
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path != '/orderdetails' && to.path != '/cart') this.loading = true
    next()
  },
  methods: {
    getData: function () {
      var url =
        this.$ajax.searchOrderList_URL +
        '?pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize +
        '&keywords=' +
        this.searchValue
      if (this.$route.query.trialorder == 1 && this.searchValue.trim() == '') {
        url += '&trialorder=' + this.$route.query.trialorder
      }
      if (this.$route.query.actgroupid) {
        url += '&actgroupid=' + this.$route.query.actgroupid
      }
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          var nowTime = new Date().getTime()
          var futureTime = null
          if (that.nowPage === 1) {
            res.data.orderlist.map((item) => {
              if (item.orderstatus == 1) {
                // 待付款
                if (item.order_time != '' && item.order_time != undefined) {
                  futureTime =
                    that.parserDate(item.order_time).getTime() +
                    parseInt(item.close_time) * 1000 * 60
                  item.time = futureTime - nowTime
                }
              }
            })
            if (res.data.orderlist && res.data.orderlist.length <= 0) {
              that.noSearchShow = true
            } else {
              that.noSearchShow = false
            }
            that.list = res.data.orderlist
            that.refresh = false
          } else {
            res.data.orderlist.map((item) => {
              if (item.orderstatus == 1) {
                // 待付款
                if (item.order_time != '' && item.order_time != undefined) {
                  futureTime = that.parserDate(item.order_time).getTime() + 30 * 60 * 1000
                  item.time = futureTime - nowTime
                }
              }
              if (item.isdeposit == 1) {
                item.finalpaymenttimestr = that.dateFn(item.finalpaymenttime, 'datetimestr')
              }
            })
            that.list = that.list.concat(res.data.orderlist)
          }
          that.loading = false
          if (res.data.orderlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    /**拼团分享 */
    groupShare: function (item) {
      if (item.joinShare && Object.keys(item.joinShare).length) {
        /**加载小程序、h5分享信息 */
        joinShare({
          that: this,
          sharetitle: item.joinShare.sharetitle || '',
          sharedesc: item.joinShare.sharedesc || '',
          shareimg: item.joinShare.shareimg || '',
          id: item.groupRecordId || '',
          code: item.groupCode
        })
        /**加载小程序、h5分享遮罩、app分享交互 */
        joinShare({
          that: this,
          sharetitle: item.joinShare.sharetitle || '',
          sharedesc: item.joinShare.sharedesc || '',
          shareimg: item.joinShare.shareimg || '',
          id: item.groupRecordId || '',
          code: item.groupCode,
          isClick: 1
        })
      }
    },
    cancel: function () {
      this.$router.go(-1)
    },
    isSpreadFn: function (index) {
      if (this.spread == null) {
        this.spread = index
      } else {
        this.spread = null
      }
    },
    goBuy: function (items) {
      if (items.isoversea == 1 && isWx != 3) {
        download_dialog(this)
        return
      }
      if (items.is_coupon == 1) {
        window.location.href =
          './static/wx/html/20190820/buyCoupon/pay.html?orderId=' +
          items.id +
          '&m=' +
          items.ordermoney
      } else {
        let skuids = []
        items.itemlist.forEach(function (item) {
          skuids.push(item.skuid)
        })
        if (items.is_drainage == 1) {
          this.$router.push({
            path: '/pay',
            query: this.groupQuery({
              id: items.id,
              money: items.ordermoney,
              yl: 1,
              ann: 1,
              anncc: 1,
              skuids: JSON.stringify(skuids)
            })
          })
        } else {
          if (items.isdeposit == 1) {
            if (items.finalpaystatus == 0) return
            this.$router.push({
              path: '/pay',
              query: this.groupQuery({
                id: items.id,
                money: items.ordermoney,
                skuids: JSON.stringify(skuids)
              })
            })
          } else {
            this.$router.push({
              path: '/pay',
              query: this.groupQuery({
                id: items.id,
                money: items.ordermoney,
                skuids: JSON.stringify(skuids)
              })
            })
          }
        }
      }
    },
    parserDate: function (date) {
      var t = Date.parse(date.replace(/-/g, '/'))
      if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, '/')))
      } else {
        return new Date()
      }
    },
    noRepeat: function () {
      if (
        localStorage.getItem('order_historylist') !== null &&
        localStorage.getItem('order_historylist') !== undefined &&
        localStorage.getItem('order_historylist') !== ''
      ) {
        this.historyList = JSON.parse(localStorage.getItem('order_historylist'))
        var historyArr = []
        var obj = {}
        this.historyList.unshift(this.searchValue)
        for (var i of this.historyList) {
          if (!obj[i]) {
            historyArr.push(i)
            obj[i] = 1
          }
        }
        if (historyArr.length > 20) {
          historyArr.splice(historyArr.length - 1, 1)
          localStorage.setItem('order_historylist', JSON.stringify(historyArr))
        } else {
          localStorage.setItem('order_historylist', JSON.stringify(historyArr))
        }
      } else {
        this.historyList.unshift(this.searchValue)
        localStorage.setItem('order_historylist', JSON.stringify(this.historyList))
      }
    },
    finish: function (id) {
      this.list[id].time = 0
      $('.countDown' + id).css('display', 'none')
    },
    search: function () {
      if (this.searchValue !== '') {
        this.noRepeat()
      }
      this.refresh = true
      this.nowPage = 1
      this.list = []
      this.onRefresh()
    },
    searchClick: function (items) {
      this.$router.push({
        path: '/productdetail',
        query: this.groupQuery({
          itemid: items.itemid
        })
      })
    },
    detailsClick: function (items) {
      this.$router.push({
        path: '/orderdetails',
        query: this.groupQuery({
          id: items.id
        })
      })
    },
    groupQuery: function (extra) {
      var query = extra || {}
      if (this.$route.query.actgroupid) {
        query.actgroupid = this.$route.query.actgroupid
      }
      if (this.$route.query.isShowIndex == 0 || this.$route.query.isShowIndex == 1) {
        query.isShowIndex = this.$route.query.isShowIndex
      }
      if (this.$route.query.newpersonhide) {
        query.newpersonhide = this.$route.query.newpersonhide
      }
      return query
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      this.getData()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    // 去换购+加购
    goProductList(items) {
      let skuids = [],
        oid = items.id,
        obj
      items.itemlist.map((item) => {
        if (
          item.isgift == 0 &&
          item.isadditem == 0 &&
          item.isprogift == 0 &&
          item.ischangebuy == 0
        ) {
          skuids.push(item.skuid)
        }
      })
      localStorage.removeItem('shopConfirmResult')
      obj = {
        skuids: skuids.join(),
        type: 'orderInfo',
        oid: oid
      }
      if (items.isexchange == 1 && items.changebuystatus != 1) {
        obj.isexchange = 1
      }
      if (items.isexchange != 1 && items.changebuystatus == 1) {
        obj.changebuystatus = 1
      }
      this.$router.push({
        path: '/allProductList',
        query: obj
      })
    },
    buyAgain: function (items) {
      var url = this.$ajax.addShoppingCart_URL
      var skuId = []
      var itemnum = []
      var liveId = []
      var list = items.itemlist
      items.itemlist.map((item) => {
        if (
          item.isgift == 0 &&
          !item.isadditem &&
          item.isprogift == 0 &&
          item.ischangebuy == 0 &&
          item.isexchangebuy == 0
        ) {
          skuId.push(item.skuid)
          itemnum.push(item.num)
          liveId.push(item.liveid)
        }
      })

      var data = {
        skuid: skuId.join(),
        itemnum: itemnum.join(),
        live_ids: liveId.join()
      }
      if (!data.skuid.length) {
        this.$router.push('/cart')
        return
      }
      var that = this
      that.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          that.$store.commit('ADD_CART_INIT_DATA', 1)
          that.dataCollection(list)
          that.$router.push('/cart')
        }
      })
    },
    // 埋点-加入购物车
    dataCollection(list) {
      let params
      for (let i in list) {
        if (
          list[i].isgift == 0 &&
          list[i].isadditem == 0 &&
          list[i].isprogift == 0 &&
          list[i].ischangebuy == 0
        ) {
          params = {
            productId_var: '',
            productName_var: list[i].name,
            firstCat_var: '',
            productType_var: '',
            productFormat_var: list[i].skuid
          }
          gio('track', 'addToCart', params)
        }
      }
    },
    confirm: function (items, id) {
      var url = this.$ajax.confirmOrderItem_URL
      var data = {
        id: items.id
      }
      var that = this
      if (items.issplit == 1) {
        that.$router.push({
          path: '/splitdetails',
          query: {
            id: items.id
          }
        })
      } else {
        if (items.orderstatus == 2 && items.status == 3) {
          this.$dialog
            .alert({
              message: '您的包裹还没有全部发货，不能确认收货！',
              className: 'percen_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '知道了',
              closeOnPopstate: false
            })
            .then(function () {
              // on confirm
            })
            .catch(function () {
              // on cancel
            })
        } else {
          this.$dialog
            .confirm({
              message: '确认收货？',
              className: 'collect_button_alert',
              cancelButtonColor: '#FC0324',
              confirmButtonColor: '#FFFCFC',
              closeOnPopstate: true
            })
            .then(function () {
              that.$customRequestAjax.post(url, data).then((res) => {
                if (res.data.code === 200) {
                  if (res.data.noticmsg) that.$toast(res.data.noticmsg)
                  that.nowPage = 1
                  that.list = []
                  that.getData()
                }
              })
            })
            .catch(function () {
              // on cancel
            })
        }
      }
    },
    afterDetailsClick: function (items) {
      this.$router.push({
        path: '/afterdetails',
        query: {
          id: items.id
        }
      })
    },
    checkTrans: function (items) {
      if (items.issplit == 0) {
        this.$router.push({
          path: '/logistics',
          query: {
            id: items.id
          }
        })
      } else if (items.issplit == 1) {
        this.$router.push({
          path: '/splitdetails',
          query: {
            id: items.id
          }
        })
      } else if (items.issplit == 2) {
        this.$router.push({
          path: '/splitdetails_order',
          query: {
            id: items.id
          }
        })
      }
    },
    keFu: function (items) {
      var goodslist = [],
        goodsnum = 0,
        money
      items.itemlist.map((item) => {
        goodslist.push({
          name: item.name,
          pictureUrl: encodeURIComponent(item.img_path)
        })
        goodsnum += parseInt(item.num)
      })
      money = parseFloat(items.ordermoney).toFixed(2)
      var k =
        'order_status=0&status_custom=' +
        items.orderstatus_text +
        '&create_time=' +
        new Date(items.order_time.replace(/-/g, '/')).getTime() +
        '&order_code=' +
        items.no +
        '&order_url=' +
        encodeURIComponent(window.location.href) +
        '&goods_count=' +
        goodsnum +
        '&total_fee=' +
        parseInt(parseFloat(money) * 100) +
        '&goods=' +
        JSON.stringify(goodslist)
      kefu(1, k)
    },
    relationordersFn: function (items) {
      if (items.relationorders && items.relationorders.length > 1) {
        this.$router.push({
          path: '/relationorders',
          query: {
            id: items.id
          }
        })
      } else if (items.relationorders && items.relationorders.length) {
        this.$router.push({ path: '/orderdetails', query: this.groupQuery({ id: items.relationorders[0].id }) })
      }
    },
    cancelFn: function (items) {
      var url = this.$ajax.cancelOrder_URL
      var data = {
        id: items.id
      }
      var that = this
      this.$dialog
        .confirm({
          message: '确认放弃优惠，取消订单吗？',
          className: 'collect_button_alert',
          cancelButtonColor: '#FC0324',
          cancelButtonText: '确认取消',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '继续支付',
          closeOnPopstate: true
        })
        .then(function () {
          // on confirm
          that.goBuy(items)
        })
        .catch(function () {
          // on cancel
          that.$customRequestAjax.post(url, data).then((res) => {
            if (res.data.code === 200) {
              that.nowPage = 1
              that.getData()
            }
          })
        })
    },
    deleteFn: function (items, id) {
      var url = this.$ajax.deleteOrder_URL
      var data = {
        id: items.id
      }
      var that = this
      this.$dialog
        .confirm({
          message: '确认删除订单？',
          className: 'collect_button_alert',
          cancelButtonColor: '#FC0324',
          confirmButtonColor: '#FFFCFC',
          closeOnPopstate: true
        })
        .then(function () {
          that.$customRequestAjax.post(url, data).then((res) => {
            if (res.data.code === 200) {
              that.list.splice(id, 1)
              if (that.list.length <= 0) {
                that.noSearchShow = true
              }
            }
          })
        })
        .catch(function () {
          // on cancel
        })
    },
    dateFn: function (date, type) {
      if (!date) return
      var arr = date.split(' ')
      var arrDateTime = arr[1].split(':')
      var arrDate = arr[0].split('-')
      if (type == 'datetime') {
        return (
          '<span><i>' +
          parseInt(arrDate[0]) +
          '</i> 年 <i>' +
          parseInt(arrDate[1]) +
          '</i> 月 <i>' +
          parseInt(arrDate[2]) +
          '</i> 日 ' +
          arrDateTime[0] +
          ':' +
          arrDateTime[1] +
          '</span>'
        )
      } else if (type == 'datetimestr') {
        // return parseInt(arrDate[0]) + '年' + parseInt(arrDate[1]) + '月' + parseInt(arrDate[2]) + '日' + arrDateTime[0] + ':' + arrDateTime[1]
        return (
          parseInt(arrDate[1]) +
          '月' +
          parseInt(arrDate[2]) +
          '日' +
          arrDateTime[0] +
          ':' +
          arrDateTime[1]
        )
      } else if (type == 'datestr') {
        return (
          parseInt(arrDate[0]) + '年' + parseInt(arrDate[1]) + '月' + parseInt(arrDate[2]) + '日'
        )
      } else {
        return (
          '<span><i>' +
          parseInt(arrDate[0]) +
          '</i> 年 <i>' +
          parseInt(arrDate[1]) +
          '</i> 月 <i>' +
          parseInt(arrDate[2]) +
          '</i> 日</span>'
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
.list ul li p,
.product {
  display: flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -webkit-flex;
  display: -o-flex;
  justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -webkit-justify-content: space-between;
  -o-justify-content: space-between;
  align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
}
header {
  z-index: 11;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  padding: 0 0.11rem 0;
  padding-right: 0.03rem;
  /*height: 0.44rem;*/
  background: #fff;
  img {
    width: 0.17rem;
    height: 0.17rem;
    position: absolute;
    left: 0.17rem;
  }
  input {
    display: block;
    width: 90%;
    border: 1px solid #fc0324;
    border-radius: 0.15rem;
    height: 0.27rem;
    padding-left: 0.32rem;
    line-height: 0.27rem;
    font-size: 0.13rem;
    color: #444;
    &::placeholder {
      font-size: 0.13rem;
      color: #999999;
    }
  }
  span {
    font-size: 0.13rem;
    color: #191818;
    display: block;
    width: 10%;
    margin-left: 0.04rem;
  }
}
.my_scroller {
  padding-top: 0.44rem;
}
.list {
  > ul {
    margin-bottom: 0.11rem;
    > li {
      background: #fff;
      margin: 0.11rem 0.11rem 0;
      padding: 0.15rem 0.15rem 0.2rem;
      > p {
        border-bottom: 1px solid #efefef;
        padding-bottom: 0.1rem;
        span {
          display: block;
          b {
            display: block;
            font-weight: 400;
            color: #444444;
            font-size: 0.12rem;
            float: left;
            &:last-of-type {
              margin-left: 0.04rem;
              line-height: 0.19rem;
              float: left;
              img {
                width: 0.19rem;
                height: 0.19rem;
                float: right;
              }
            }
          }
        }
        > b {
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          align-items: center;
          -webkit-align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          -o-align-items: center;
          i {
            display: inline-block;
            font-style: normal;
            color: #292929;
            font-size: 0.12rem;
            line-height: 0.16rem;
            float: left;
            font-weight: 400;
          }
          b {
            display: inline-block;
            border-left: 1px solid #d8d8d8;
            margin-left: 0.06rem;
            padding-left: 0.07rem;
            img {
              width: 0.12rem;
              height: 0.12rem;
            }
          }
        }
      }
      .product {
        margin-top: 0.16rem;
        position: relative;
        .img {
          width: 0.8rem;
          height: 0.8rem;
          position: relative;
          img {
            &:first-of-type {
              width: 100%;
              height: 100%;
            }
          }
        }
        .productBox {
          display: flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -webkit-flex;
          display: -o-flex;
          img {
            width: 0.8rem;
            height: 0.8rem;
          }
          .proContent {
            margin-left: 0.07rem;
            margin-top: 0.08rem;
            flex: 1;
            -webkit-flex: 1;
            -moz-flex: 1;
            -ms-flex: 1;
            -o-flex: 1;
            > b {
              font-size: 0.13rem;
              font-weight: 400;
              color: rgba(41, 41, 41, 1);
              line-height: 0.18rem;
              display: block;
              margin-bottom: 0.05rem;
            }
            > p {
              align-items: flex-start;
              -moz-align-items: flex-start;
              -ms-align-items: flex-start;
              -webkit-align-items: flex-start;
              -o-align-items: flex-start;
              > b {
                font-size: 0.11rem;
                font-weight: 400;
                color: rgba(108, 108, 108, 1);
                line-height: 0.16rem;
                display: block;
              }
            }
          }
        }
        .totalPrice {
          /*position: absolute;*/
          right: 0;
          z-index: 10;
          opacity: 0.85;
          height: 0.8rem;
          display: flex;
          display: -webkit-flex;
          display: -o-flex;
          display: -ms-flex;
          display: -moz-flex;
          flex-direction: column;
          -webkit-flex-direction: column;
          -o-flex-direction: column;
          -ms-flex-direction: column;
          -moz-flex-direction: column;
          justify-content: center;
          -webkit-justify-content: center;
          -o-justify-content: center;
          -ms-justify-content: center;
          -moz-justify-content: center;
          .price {
            display: flex;
            display: -webkit-flex;
            display: -o-flex;
            display: -ms-flex;
            display: -moz-flex;
            align-items: flex-end;
            -webkit-align-items: flex-end;
            -o-align-items: flex-end;
            -ms-align-items: flex-end;
            -moz-align-items: flex-end;
            font-size: 0.14rem;
            font-weight: 600;
            color: #222222;
            line-height: 0.14rem;
            &:before {
              content: '￥';
              font-size: 0.1rem;
              font-weight: 600;
              line-height: 0.14rem;
            }
            i {
              font-size: 0.11rem;
              font-style: normal;
              line-height: 0.14rem;
            }
          }
          > b {
            color: #908d8d;
            font-size: 0.11rem;
            line-height: 0.16rem;
            display: block;
            font-weight: 400;
            text-align: center;
          }
        }
        .bestSellingSwiper {
          width: 100%;
          .swiper-container {
            padding-right: 0.6rem;
            .swiper-wrapper {
              > .swiper-slide {
                width: 0.8rem;
                position: relative;
                background-color: white;
              }
            }
          }
          & + .totalPriceShadow {
            position: absolute;
            background: rgba(255, 255, 255, 1);
            box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
            -webkit-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
            -moz-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
            -ms-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
            -o-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
          }
          & + .totalPriceNoShadow {
            position: static;
            background: rgba(255, 255, 255, 1);
          }
        }
      }
      .proFooter {
        margin-top: 0.1rem;
        overflow: hidden;
        > .p {
          font-size: 0.1rem;
          font-weight: 400;
          color: rgba(252, 3, 36, 1);
          line-height: 0.26rem;
          float: left;
          &.q {
            color: #7b44f6;
            line-height: 0.14rem;
            width: 100%;
            height: 0.14rem;
            overflow: hidden;
            margin-bottom: 0.08rem;
            &.spread {
              height: auto;
              overflow: initial;
              margin-bottom: 0;
            }
            p {
              display: flex;
              display: -webkit-flex;
              display: -moz-flex;
              display: -ms-flex;
              display: -o-flex;
              align-items: center;
              -webkit-align-items: center;
              -moz-align-items: center;
              -ms-align-items: center;
              -o-align-items: center;
              justify-content: left;
              -webkit-justify-content: left;
              -moz-justify-content: left;
              -ms-justify-content: left;
              -o-justify-content: left;
              margin-bottom: 0.08rem;
              height: 0.14rem;
              span {
                max-width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              &.spread {
                height: auto;
                overflow: initial;
                margin-bottom: 0;
                span {
                  max-width: initial;
                  white-space: initial;
                  overflow: initial;
                  text-overflow: initial;
                }
              }
            }
          }
        }
        .proBtn {
          display: flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -webkit-flex;
          display: -o-flex;
          float: right;
          .grayBtn {
            white-space: nowrap;
            min-width: 0.7rem;
            height: 0.27rem;
            display: block;
            margin-left: 0.1rem;
            border-radius: 0.14rem;
            border: 1px solid rgba(96, 96, 96, 1);
            font-size: 0.12rem;
            font-weight: 400;
            color: rgba(38, 38, 38, 1);
            line-height: 0.17rem;
            padding: 0.05rem 0.11rem;
            background: none;
            outline: none;
          }
          .redBtn {
            white-space: nowrap;
            min-width: 0.7rem;
            height: 0.27rem;
            display: block;
            margin-left: 0.1rem;
            border-radius: 0.14rem;
            border: 1px solid #fc0324;
            font-size: 0.12rem;
            font-weight: 400;
            color: #fc0324;
            line-height: 0.17rem;
            padding: 0.05rem 0.11rem;
            background: none;
            outline: none;
            &.orangeBtn {
              border-color: #ffb346;
              color: #ffb346;
            }
          }
          .grayBackBtn {
            min-width: 0.7rem;
            height: 0.27rem;
            display: block;
            margin-left: 0.1rem;
            background: rgba(221, 221, 221, 1);
            border-radius: 0.14rem;
            font-size: 0.12rem;
            font-weight: 400;
            color: rgba(255, 252, 252, 1);
            line-height: 0.17rem;
            padding: 0.05rem 0.11rem;
            outline: none;
            border: 1px solid rgba(221, 221, 221, 1);
          }
        }
      }
    }
  }
  .subscribe {
    background: #f9e7f1;
    color: #ff5c7b;
    border-radius: 0.12rem;
    padding-right: 0.1rem;
    height: 0.23rem;
    img {
      width: 0.6rem;
      height: 0.23rem;
    }
  }
}
</style>
<style lang="scss">
.orderSearchList .van-count-down {
  font-size: 0.1rem;
  font-weight: 400;
  color: #fc0324;
  line-height: 0.14rem;
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderSearchList.vue